import { Component, Input, ViewChild } from '@angular/core';
import { CreateEditInstructionsModel } from '../create-edit-instructions/create-edit-instructions.model';
import { messageConstants } from '../../shared/constants';
import { SymbolSearchService } from '../../shared/components/symbol-search/symbol-search.service';
import { SymbolRecord } from '../../shared/components/symbol-search/symbol-search.model';
import { CreateEditInstructionsViewMode, MutualFundInvestingService } from '../mutual-fund-investing.service';
import { ContentSpinnerComponent } from '@charlesschwab/as-ui-core';
import { DurationValues } from '../../shared/constants/filter-constants';
import moment from 'moment';
import { InstructionActionsComponent } from '../instruction-actions/instruction-actions-component';
import { DecimalPipe, CurrencyPipe } from '@angular/common';
import { AccountNumberPipe } from '../../shared/pipes/account-number.pipe';

@Component({
    selector: 'preview-instructions',
    templateUrl: './preview-instructions.component.html',
    styleUrls: ['./preview-instructions.component.scss'],
    standalone: true,
    imports: [InstructionActionsComponent, DecimalPipe, CurrencyPipe, AccountNumberPipe]
})
export class PreviewInstructionsComponent {
  @Input() previewData: CreateEditInstructionsModel;
  @Input() showError: boolean;
  @Input() showActionButtons: boolean = false;
  @Input() viewMode: string;
  @Input() transactionFee: string;
  transactionFeeMessage: string;
  dayToExecuteLabel: string;
  @ViewChild(ContentSpinnerComponent)
  SchSpinnerComponent?: ContentSpinnerComponent;

  constructor(
    private symbolSearchService: SymbolSearchService,
    private mfInvestingService: MutualFundInvestingService
  ) {}

  loadInstructionData(): void {
    this.showSpinner();
    try {
      this.dayToExecuteLabel = messageConstants.executeTransactionOn;
      this.transactionFeeInfo();
      if (this.viewMode === CreateEditInstructionsViewMode.VIEW_INSTRUCTION) {
        this.symbolSearchService
          .getAvailableFundsForAccount({
            accountId: this.previewData.account,
            itemIssueId: parseInt(this.previewData.itemIssueId, 10)
          })
          .subscribe(
            (response) => {
              const symbolRecord: SymbolRecord = response?.data?.attributes.elgibleInstructions[0];
              symbolRecord.accountControlNumber = response?.data?.attributes.accountControlNumber;

              if (this.viewMode === CreateEditInstructionsViewMode.VIEW_INSTRUCTION) {
                if (symbolRecord.discretionaryInd != null && symbolRecord.discretionaryInd != undefined) {
                  this.previewData.discretionaryInd = symbolRecord.discretionaryInd;
                }
                if (symbolRecord.solicitedInd != null && symbolRecord.solicitedInd != undefined) {
                  this.previewData.solicitedInd = symbolRecord.solicitedInd;
                }
                if (symbolRecord.accountControlNumber !== null && symbolRecord.accountControlNumber !== undefined) {
                  this.previewData.accountControlNumber = symbolRecord.accountControlNumber.toString();
                }
                if (symbolRecord.instructionContext !== null && symbolRecord.instructionContext !== undefined) {
                  this.previewData.instructionContext = symbolRecord.instructionContext;
                }
                if (symbolRecord.clndAuditIntgCntlNr !== null && symbolRecord.clndAuditIntgCntlNr !== undefined) {
                  this.previewData.clndAuditIntgCntlNr = symbolRecord.clndAuditIntgCntlNr;
                }

                //if restart date AND end date are populated AND both are in the past THEN end date is set to a blank string
                if (symbolRecord.endDate != null && symbolRecord.restartDate != null) {
                  let endDateTime = new Date(symbolRecord.endDate);
                  let restartDateTime = new Date(symbolRecord.restartDate);
                  let todayDateTime = new Date();

                  if (endDateTime <= todayDateTime && restartDateTime <= todayDateTime) {
                    this.previewData.endDate = symbolRecord.endDate;
                    this.previewData.duration = DurationValues.runUntilStopped;
                    this.previewData.isRestarted = true;
                  }
                }
              }
              this.hideSpinner();

              if (response?.data?.attributes.hasTradeDataAccess) {
                this.showActionButtons = true;
              } else {
                this.showActionButtons = false;
                this.mfInvestingService.showHideInstructionNotification({
                  notificationType: 'error',
                  notificationBold: messageConstants.noTradeDataAccessHeading,
                  messages: [messageConstants.noTradeDataAccessMessage]
                });
              }

              return (this.previewData.securityName = symbolRecord.fundSymbol + ' - ' + symbolRecord.fundName);
            },
            (error) => {
              this.hideSpinner();
              this.showActionButtons = false;
              this.mfInvestingService.showHideInstructionNotification({
                notificationType: 'error',
                messages: ['There was an error retrieving the data for this instruction. Please close it and try again.']
              });
            }
          );
      } else {
        this.hideSpinner();
      }
    } catch (e) {
      //
    }
  }

  restartDateExistsAndStopDateIsBeforeRestartDate(instructionData: CreateEditInstructionsModel): boolean {
    if (instructionData.restartDate) {
      if (
        moment(moment(instructionData.endDate, 'MM/DD/YYYY')).isBefore(
          moment(instructionData.restartDate, 'MM/DD/YYYY'),
          'day'
        )
      ) {
        return true;
      }
    }
    return false;
  }

  showSpinner(): void {
    if (this.SchSpinnerComponent) {
      this.SchSpinnerComponent.show();
    }
  }

  hideSpinner(): void {
    if (this.SchSpinnerComponent) {
      this.SchSpinnerComponent.hide();
    }
  }

  transactionFeeInfo(): void {
    if (this.transactionFee === '' || this.transactionFee == null || this.transactionFee == undefined) {
      this.transactionFeeMessage = '(Unable to calculate est. fee per transaction)';
    } else {
      this.transactionFeeMessage = '($' + this.transactionFee + ' est. fee per transaction)';
    }
  }
}
